if (!customElements.get('card-product-slider')) {
  class CardProductSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.requiresFetch = this.hasAttribute('data-url');
      this.parent = this.closest('[data-section-id]');
      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        slidesPerView: 'auto',
        resistanceRatio: 0.72,
        navigation: {
          nextEl: '.product-feed__swiper-button--next',
          prevEl: '.product-feed__swiper-button--prev'
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          }
        }
      };
    }

    connectedCallback() {
      if (this.requiresFetch) {
        this.fetchItems();
        return;
      }
      this.initSlider();
    }

    fetchItems() {
      if (!this.parent) throw new Error('Parent is missing');
      fetch(this.getAttribute('data-url'))
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(
            text,
            'text/html'
          );
          const wrapper = html.querySelector('.swiper-wrapper');

          if (wrapper && wrapper.innerHTML.trim().length) {
            this.querySelector('.swiper-wrapper').innerHTML =
              wrapper.innerHTML;
            this.parent.classList.remove('hidden');
            this.initSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    initSlider(slider = this) {
      this.slider = new Swiper(slider, this.sliderOptions);

      this.slider.wrapperEl.setAttribute('aria-live', 'polite');
      this.slider.wrapperEl.id = `swiper-wrapper-${this.dataset.sectionId}`;
      this.slider.slides.forEach((slide, i) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute(
          'aria-label',
          `${i + 1} / ${this.slider.slides.length}`
        );
        slide.dataset.index = i;
      });
      const sliderButtons = [
        this.slider.navigation.prevEl,
        this.slider.navigation.nextEl
      ];

      sliderButtons.forEach((button, i) => {
        let type = 'Previous';

        if (i === 1) {
          type = 'Next';
        }

        button.setAttribute('aria-label', `${type} slide`);
        button.setAttribute(
          'aria-controls',
          this.slider.wrapperEl.id
        );
      });

      this.slider.wrapperEl.addEventListener('focusin', e => {
        this.slider.el.scrollLeft = 0;

        const slide = e.target.closest('.swiper-slide');
        const slideIndex = +slide.dataset.index;
        const isFirstSlide = slideIndex === 0;
        const isLastSlide =
          slideIndex === this.slider.slides.length - 1;

        if (isFirstSlide || isLastSlide) {
          this.slider.slideTo(slideIndex, 0);

          return;
        }

        const slideRect = slide.getBoundingClientRect();
        const wrapperWidth = this.slider.wrapperEl.clientWidth;
        // prettier-ignore
        const slideLeft = slideRect.x + slideRect.width - ((document.body.clientWidth - wrapperWidth) / 2);
        const isSlideVisible =
          slideLeft <= wrapperWidth && slideLeft >= slideRect.width;

        if (isSlideVisible) {
          return;
        }

        slideLeft >= slideRect.width
          ? this.slider.slideNext(0)
          : this.slider.slidePrev(0);
      });
    }
  }

  customElements.define('card-product-slider', CardProductSlider);
}


// adjust slider button
function setSliderButtonPosition() {
  // Adjust slider button for active tab content
  const cardProductMedia = document.querySelector('.product-feed .products-feed__tabcontent-wrapper.active .card-product__media');

  if (cardProductMedia) {
    const cardProductHeight = cardProductMedia.clientHeight;
    const sliderButtons = document.querySelectorAll('.product-feed .products-feed__tabcontent-wrapper.active .card-product-slider__buttons');
    
    sliderButtons.forEach(button => {
      const sliderButtonsHeight = button.clientHeight;
      button.style.top = (cardProductHeight * 0.5 - sliderButtonsHeight * 0.5) + 'px';
    });
  }

  // Section recommendation
  const cardProductMediaRe = document.querySelector('.section-recommendation .product-feed .card-product__media');

  if (cardProductMediaRe) {
    const cardProductHeightRe = cardProductMediaRe.clientHeight;
    const sliderButtonsRe = document.querySelectorAll('.section-recommendation .product-feed .card-product-slider__buttons');
    
    sliderButtonsRe.forEach(button => {
      const sliderButtonsHeightRe = button.clientHeight;
      button.style.top = (cardProductHeightRe * 0.5 - sliderButtonsHeightRe * 0.5) + 'px';
    });
  }
}

window.onload = setSliderButtonPosition;
window.onresize = setSliderButtonPosition;